import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import { Location } from "@angular/common";
import { CategoriaService } from "src/app/services/categorias/categoria";
import { MessageService } from "primeng/api";
import { FechasService } from "src/app/services/fechas/fechas";
import { ColumnManagerService } from "src/app/services/column-manager/column-manager.service";
import { GenericService } from "src/app/services/generic/generic.service";
import { routes } from "src/app/app.routes";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-column-manager",
  templateUrl: "./column-manager.component.html",
  styleUrls: ["./column-manager.component.css"],
  providers: [CategoriaService, MessageService, FechasService],
})
export class ColumnManagerComponent implements OnInit {
  @Input() displayColumnManager: boolean;
  // @Input() categoria = "";
  @Output() cerrarColumnManager = new EventEmitter();

  availableColumns: any[] = [];
  selectedColumns: any[] = [];
  dropIndex: number | null = null;

  columnName = "module_name";
  database = "column_manager";

  update: boolean = false;
  id: any = "";

  loaderSubmit: boolean = false;

  childrenDatabaseName: string = "";



  constructor(
    private columnService: ColumnManagerService,
    private genericService: GenericService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute

  ) {}

  // ngOnInit() {
  //   const nameUrl = this.location.path().replace("/dashboard/", "");
  //   const dashboardRoute = routes.find(route => route.path === 'dashboard');
  //   if (dashboardRoute) {
  //       const children = dashboardRoute.children.find(child => child.path === nameUrl);
  //       this.childrenDatabase = children.data.database
  //       if (children.data.database){
  //         this.categoria = this.childrenDatabase
  //       }else{
  //         this.categoria = nameUrl
  //       }
  //   }

  //   if (this.categoria) {
  //     this.loadTableColumns(this.categoria);
  //     this.fetchRowForCategory(this.categoria);
  //   }
  // }

  ngOnInit() {
    if (environment.appName === 'campanaragricola') {
      return;
    }
    // Every time user reaches a new route, this.updateRouteData will be called
    this.router.events
    .pipe(filter((event) => event instanceof NavigationEnd))
    .subscribe(() => {
      this.updateRouteData();
    });

    this.updateRouteData();
  }


  private updateRouteData() {
    const nameUrl = this.location.path().replace("/dashboard/", "");
    const dashboardRoute = routes.find((route) => route.path === "dashboard");
    if (dashboardRoute) {
      const children = dashboardRoute.children.find(
        (child) => child.path === nameUrl
      );
      if (children && children.data) {
        this.childrenDatabaseName = children.data.database || "";
      } else {
        this.childrenDatabaseName = "";
      }
      this.childrenDatabaseName = this.childrenDatabaseName || nameUrl;
      if (this.childrenDatabaseName && !this.childrenDatabaseName.includes("/")) {
        if (this.childrenDatabaseName === 'grafica' || this.childrenDatabaseName === 'usuario'){
          return
        }
        this.loadTableColumns(this.childrenDatabaseName);
        this.fetchRowForCategory(this.childrenDatabaseName);
        // this.obtainTableComment(this.categoria)
      }
    }
  }

  // private updateRouteData() {
  //   if (this.route.snapshot.firstChild){
  //     const nameUrl = this.route.snapshot.firstChild.routeConfig.path;
  //     let childrenDatabase = this.route.snapshot.firstChild.data.database ? this.route.snapshot.firstChild.data.database : nameUrl;

  //     this.childrenDatabaseName = childrenDatabase
  //     if (childrenDatabase) {
  //       console.log(childrenDatabase)
  //       this.loadTableColumns(childrenDatabase);
  //       this.fetchRowForCategory(childrenDatabase);
  //     }
  //   }
  // }

  // Obtains all selected columns from a table, those selected are removed from all fields
  // If the column has a 'comment', then it will be changed to be more descriptive
  async fetchRowForCategory(categoria: string): Promise<void> {
    if (!categoria) return;

    try {
      //Obtain selected columns
      const data: any = await this.columnService
        .fetchRow(this.columnName, categoria, this.database)
        .toPromise();
      // New module being modified
      if (data.status !== 200 || !data.row_data) {
        this.update = false;
        this.id = "0";
        this.selectedColumns = [];
        return;
      }
      // Updating columns of a module
      this.update = true;
      this.id = data.row_data.id;
      if (data.row_data.order_columns === ''){
        this.selectedColumns = []
        return
      }
      const columnNamesFromDb = data.row_data.order_columns.split(";");
      //Obtain comments of each column
      const commentsData: any = await this.columnService
        .fetchColumnComments(categoria)
        .toPromise();
      if (commentsData.status !== 200) {
        console.error("Error loading column comments:", commentsData.message);
        return;
      }
      const columnComments = commentsData.columns_info;
      const uniqueColumnNames = Array.from(new Set(columnNamesFromDb));
      // Inserts on selected columns array each column selected, value will always be the same,
      // but if there is a comment, name will be changed
      this.selectedColumns = uniqueColumnNames.map((columnName: any) => {
        const comment =
          columnComments[columnName] && columnComments[columnName].comment
            ? columnComments[columnName].comment.split("|", 1)[0].trim()
            : "";
        return {
          name: comment || columnName,
          value: columnName,
        };
      });
      // Filters all columns, removing those who are selected
      this.availableColumns = this.availableColumns.filter(
        (ac) => !this.selectedColumns.some((sc) => sc.value === ac.value)
      );
    } catch (error) {
      console.error("Error fetching row or column comments:", error);
      this.update = false;
      this.id = "0";
      this.selectedColumns = [];
    }
  }

  // Obtains all fields from a table
  async loadTableColumns(tableName: string): Promise<void> {
    try {
      //console.log('Test')
      const response: any = await this.columnService
        .fetchColumnComments(tableName)
        .toPromise();
      if (response.status === 200) {
        const columnComments = response.columns_info;
        // Inserts on all columns array. Each column name will be changed by the comment if it exists
        this.availableColumns = Object.keys(columnComments)
          .filter((columnName) => columnName !== "id" && columnName !== 'revision')
          .map((columnName) => {
            const comment = columnComments[columnName].comment.split("|", 1)[0];
            return {
              name: comment !== "" ? comment : columnName,
              value: columnName,
            };
          });
      } else {
        console.error("Error loading column comments:", response.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  dragStart(event: DragEvent, item: any) {
    if (event.dataTransfer) {
      event.dataTransfer.setData("text", item.name);
      event.dataTransfer.effectAllowed = "move";
    }
  }

  // dragOver(event: DragEvent, index?: number) {
  //   event.preventDefault();
  //   if (index !== undefined) {
  //     this.dropIndex = index;
  //   }
  //   event.stopPropagation();
  // }
  dragOver(event: DragEvent, index?: number) {
    event.preventDefault();
    if (!event.target) return;

    const target = event.target as HTMLElement;
    const listElement = target.closest('li');
    if (listElement) {
      const boundingRect = listElement.getBoundingClientRect();
      const middleY = boundingRect.top + boundingRect.height / 2;
      if (event.clientY < (middleY)) {
        this.dropIndex = index;
      } else {
        this.dropIndex = index + 1;
      }
    }
    event.stopPropagation();
  }


  // dropSelected(event: DragEvent, index: number) {
  //   event.preventDefault();
  //   if (event.dataTransfer) {
  //     const itemName = event.dataTransfer.getData("text");

  //     let draggedItem = this.availableColumns.find(
  //       (item) => item.name === itemName
  //     );
  //     let fromAvailable = true;

  //     if (!draggedItem) {
  //       draggedItem = this.selectedColumns.find(
  //         (item) => item.name === itemName
  //       );
  //       fromAvailable = false;
  //     }

  //     if (draggedItem) {
  //       if (fromAvailable) {
  //         this.availableColumns = this.availableColumns.filter(
  //           (item) => item.name !== itemName
  //         );
  //       } else {
  //         this.selectedColumns = this.selectedColumns.filter(
  //           (item) => item.name !== itemName
  //         );
  //       }
  //       this.selectedColumns.splice(index, 0, draggedItem);
  //     }
  //   }
  // }

  dropSelected(event: DragEvent, index: number) {
    event.preventDefault();
    if (event.dataTransfer) {
      const itemName = event.dataTransfer.getData("text");
      let draggedItem = this.availableColumns.find(item => item.name === itemName);
      let fromAvailable = true;

      if (!draggedItem) {
        draggedItem = this.selectedColumns.find(item => item.name === itemName);
        fromAvailable = false;
      }

      if (draggedItem) {
        if (fromAvailable) {
          this.availableColumns = this.availableColumns.filter(item => item.name !== itemName);
        } else {
          this.selectedColumns = this.selectedColumns.filter(item => item.name !== itemName);
        }
        this.selectedColumns.splice(this.dropIndex !== null && this.dropIndex !== undefined ? this.dropIndex : index, 0, draggedItem);
      }
    }
  }



  dropAvailable(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer) {
      const itemName = event.dataTransfer.getData("text");
      const draggedItem = this.selectedColumns.find(
        (item) => item.name === itemName
      );
      if (draggedItem) {
        this.availableColumns.push(draggedItem);
        this.selectedColumns = this.selectedColumns.filter(
          (item) => item.name !== itemName
        );
      }
    }
  }

  drop(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer) {
      const itemName = event.dataTransfer.getData("text");
      const draggedItem = this.availableColumns.find(
        (item) => item.name === itemName
      );
      if (draggedItem) {
        this.selectedColumns.push(draggedItem);
        this.availableColumns = this.availableColumns.filter(
          (item) => item.name !== itemName
        );
      }
    }
  }

  save() {
    this.loaderSubmit = true;
    const selectedColumnNames = this.selectedColumns
      .map((column) => column.value)
      .join(";");

    const testObject = {
      id: this.id ? this.id : "0",
      module_name: this.childrenDatabaseName,
      order_columns: selectedColumnNames,
    };

    if (this.update) {
      this.genericService
        .update(testObject, "column_manager")
        .toPromise()
        .then((resp: any) => {
          //console.log(resp);
          this.cerrarVentanaColumnManager();
          this.loaderSubmit = false;
          window.location.reload();
        });
    } else {
      this.genericService
        .create(testObject, "column_manager")
        .toPromise()
        .then((resp: any) => {
          //console.log(resp);
          this.cerrarVentanaColumnManager();
          this.loaderSubmit = false;
          window.location.reload();
        });
    }

  }

  moveToSelected(item: any) {
    this.availableColumns = this.availableColumns.filter(
      (ac) => ac.name !== item.name
    );
    this.selectedColumns.push(item);
  }

  moveToAvailable(item: any) {
    this.selectedColumns = this.selectedColumns.filter(
      (sc) => sc.name !== item.name
    );
    this.availableColumns.push(item);
  }

  cerrarVentanaColumnManager() {
    this.cerrarColumnManager.emit({});
  }
}
